import {fetchJSONByGet, fetchJSONByPost, fetchJSONByPut, fetchJSONByDel} from './index.js'

// 查询子账户列表
export const cargoStaffPageApi = (params) => fetchJSONByGet('/admin-api/ins/company/cargo/list/child', params)
// 创建子账户
export const createStaffApi = (body) => fetchJSONByPost('/admin-api/ins/company/cargo/register/staff', body)
// 获取商家商品列表
export const productPageApi = (companyCode, params) => fetchJSONByGet(`/admin-api/ins/product/page/${companyCode}`, params)
// 查看合作伙伴收益明细
export const earningsPageApi = (params) => fetchJSONByGet('/admin-api/ins/company/earnings/1/page', params)
// 获取子账户列表
export const cargoAllStaffApi = () => fetchJSONByGet('/admin-api/ins/company/cargo/childs')